/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/DataInput/dataCollectionGuide.ts.
 */

export const DATA_COLLECTION_GUIDE = {
  href: "/file/ICoMEC_Guide_to_filling_the_Data_Collection_Template_11Jun2026.pdf",
  downloadName: "ICoMEC_Guide to filling the Data Collection Template_11Jun2026.pdf",
  label: "Download data collection guide (PDF)",
} as const;
